import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

// Context
import { AuthProvider } from "./contexts/AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import FacilityDetailPage from "./pages/FacilityDetailPage";
import StatePage from "./pages/StatePage";
import StatesListPage from "./pages/StatesListPage";
import TreatmentTypesPage from "./pages/TreatmentTypesPage";
import InsurancePage from "./pages/InsurancePage";
import ResourcesPage from "./pages/ResourcesPage";
import GetHelpPage from "./pages/GetHelpPage";
import FacilitySignupPage from "./pages/FacilitySignupPage";
import FacilitySignupSuccessPage from "./pages/FacilitySignupSuccessPage";
import FacilityLoginPage from "./pages/FacilityLoginPage";
import FacilityDashboardPage from "./pages/FacilityDashboardPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SitemapPage from "./pages/SitemapPage";
import NotFoundPage from "./pages/NotFoundPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import LeadOfferPage from "./pages/LeadOfferPage";
import CRMDashboard from "./pages/CRMDashboard";
import RobotsTxt from "./components/RobotsTxt";
import SitemapXml from "./components/SitemapXml";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App min-h-screen bg-white">
          <Routes>
            {/* Admin Login Route (no header/footer) */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            
            {/* Protected Admin Routes */}
            <Route
              path="/admin/crm"
              element={
                <ProtectedRoute requiredRole="admin">
                  <div className="flex flex-col min-h-screen">
                    <Header />
                    <main className="flex-1">
                      <CRMDashboard />
                    </main>
                    <Footer />
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute requiredRole="admin">
                  <div className="flex flex-col min-h-screen">
                    <Header />
                    <main className="flex-1">
                      <AdminDashboardPage />
                    </main>
                    <Footer />
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/facility-dashboard"
              element={
                <ProtectedRoute requiredRole="facility" loginPath="/facility-login">
                  <div className="flex flex-col min-h-screen">
                    <Header />
                    <main className="flex-1">
                      <FacilityDashboardPage />
                    </main>
                    <Footer />
                  </div>
                </ProtectedRoute>
              }
            />
            
            {/* Public Routes with Header/Footer */}
            <Route path="/*" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-1">
                  <Routes>
                    <Route index element={<HomePage />} />
                    <Route path="search" element={<SearchPage />} />
                    <Route path="states" element={<StatesListPage />} />
                    <Route path="states/:stateCode" element={<StatePage />} />
                    <Route path="facility/:id" element={<FacilityDetailPage />} />
                    
                    {/* Information Pages */}
                    <Route path="treatment-types" element={<TreatmentTypesPage />} />
                    <Route path="insurance" element={<InsurancePage />} />
                    <Route path="resources" element={<GetHelpPage />} />
                    <Route path="get-help" element={<GetHelpPage />} />
                    
                    {/* Facility Management Routes */}
                    <Route path="facility-signup" element={<FacilitySignupPage />} />
                    <Route path="facility-signup/success" element={<FacilitySignupSuccessPage />} />
                    <Route path="facility-login" element={<FacilityLoginPage />} />
                    {/* facility-dashboard and admin-dashboard are registered above, gated by ProtectedRoute */}

                    {/* Lead Generation - TEMPORARILY DISABLED */}
                    {/* <Route path="get-leads" element={<LeadOfferPage />} /> */}
                    
                    {/* Legal & Info Pages */}
                    <Route path="about" element={<AboutPage />} />
                    <Route path="contact" element={<ContactPage />} />
                    <Route path="terms" element={<TermsPage />} />
                    <Route path="privacy" element={<PrivacyPage />} />
                    <Route path="sitemap" element={<SitemapPage />} />
                    
                    {/* Blog Routes */}
                    <Route path="blog" element={<BlogPage />} />
                    <Route path="blog/:slug" element={<BlogPostPage />} />
                    
                    {/* /crm used to render CRMDashboard directly here with no auth check at all -
                        redirect through the properly gated /admin/crm route instead */}
                    <Route path="crm" element={<Navigate to="/admin/crm" replace />} />
                    
                    {/* SEO Files as Routes */}
                    <Route path="robots.txt" element={<RobotsTxt />} />
                    <Route path="sitemap.xml" element={<SitemapXml />} />
                    
                    {/* 404 Page */}
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            } />
          </Routes>
          
          <Toaster />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;